import type { ComponentProps } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

type FormFieldProps = ComponentProps<"input"> & {
  label: string;
  id: string;
  containerClassName?: string;
};

export function FormField({ label, id, className, containerClassName, ...props }: FormFieldProps) {
  return (
    <div className={cn("grid gap-1.5", containerClassName)}>
      <Label htmlFor={id}>{label}</Label>
      <Input id={id} className={className} {...props} />
    </div>
  );
}
